import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useOnboardingStatus() {
  const [needsOnboarding, setNeedsOnboarding] = useState(false);
  const [loading, setLoading] = useState(true);

  const check = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setNeedsOnboarding(false);
        setLoading(false);
        return;
      }

      // Check role first — coaches and admins never need onboarding
      const { data: roleData } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .maybeSingle();

      if (roleData && (roleData.role === 'coach' || roleData.role === 'admin')) {
        setNeedsOnboarding(false);
        setLoading(false);
        return;
      }

      // Check if client has completed onboarding
      const { data: profile } = await supabase
        .from('client_onboarding_profiles')
        .select('onboarding_completed')
        .eq('user_id', user.id)
        .maybeSingle();

      setNeedsOnboarding(!profile || !profile.onboarding_completed);
    } catch {
      setNeedsOnboarding(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    check();

    // Re-check whenever auth state changes (e.g. after onboarding completes and navigates to /)
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      check();
    });

    return () => subscription.unsubscribe();
  }, []);

  return { needsOnboarding, loading, refetch: check };
}
